import React from 'react';
import {IconProps} from "../../types/types";

const LoginIcon: React.FC<IconProps> = ({size = 32, color = 'white', ...props}) => (
    <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="32" height="32" rx="16"/>
        <path
            d="M22.5 14L24 15.5L27 12.5M19 11C19 13.2091 17.2091 15 15 15C12.7909 15 11 13.2091 11 11C11 8.79086 12.7909 7 15 7C17.2091 7 19 8.79086 19 11ZM11 18H19C21.2091 18 23 19.7909 23 22C23 22.5523 22.5523 23 22 23H8C7.44772 23 7 22.5523 7 22C7 19.7909 8.79086 18 11 18Z"
            stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

);

export default LoginIcon;